import React, { useEffect, useState } from 'react';
import BaseModel from '../BaseModal';
import { FlexWrapperCenter, GapView } from '../styles/WrapperStyles';
import { BaseButton } from '../styles/ButtonStyles';
import styled, { css } from 'styled-components';
import Cropper from "react-cropper";
import rotate_left from '../assests/rotate_left.png';
import rotate_right from '../assests/rotate_right.png';
import "cropperjs/dist/cropper.css";
import { useRef } from 'react';


const RotateImage = styled.img`
  cursor: pointer;
  width: 30px;
  height: 30px;
  ${props =>
        props.left &&
        css`
      margin-right: 10px;
    `}
`;



const CropImage = (props) => {
    const [rotate, setRotate] = useState(0);
    const EditorRef = useRef(null);

    const showCroppedImage = () => {
        props.saveCroppedImage(EditorRef.current?.cropper.rotate(rotate).getCroppedCanvas().toDataURL())
    };

    return (
        <BaseModel closeModal={props.closeModal}>
            <Cropper
                ref={EditorRef}
                style={{ height: 350, width: 350, transform: `rotate(${rotate}deg)` }}
                zoom={50}
                initialAspectRatio={1}
                src={props.photo}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={false}
                autoCropArea={1}
                checkOrientation={true}
                guides={false}
                zoomOnWheel={true}
                onWheel={() => { }}
                rotateTo={rotate}
                cropBoxMovable={true}
                cropBoxResizable={false}
            />

            <GapView height="20px" />
            <FlexWrapperCenter>
                <RotateImage
                    left
                    src={rotate_left}
                    onClick={() => { setRotate(rotate - 90) }}
                />
                <RotateImage
                    src={rotate_right}
                    onClick={() => { setRotate(rotate + 90) }}
                />
            </FlexWrapperCenter>
            <FlexWrapperCenter>
                <BaseButton onClick={() => showCroppedImage()}>Save</BaseButton>
            </FlexWrapperCenter>
        </BaseModel>
    )
};

export default CropImage;
